export default __webpack_public_path__ + "static/media/AI.7613415c.ico";